import { Stack } from '@mui/material'
import MuiTextField, { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField'
import { FieldProps } from 'formik'
import { ValidationMessages } from '../ValidationMessages'

export interface TextFieldProps
  extends FieldProps,
    Omit<MuiTextFieldProps, 'name' | 'value' | 'error'> {}

export function TextField({
  children,
  disabled,
  onBlur,
  field: { onBlur: fieldOnBlur, ...field },
  form: { isSubmitting },
  ...props
}: TextFieldProps) {
  return (
    <Stack>
      <MuiTextField
        {...{
          disabled: disabled ?? isSubmitting,
          onBlur:
            onBlur ??
            function (e) {
              fieldOnBlur(e ?? field.name)
            },
          ...field,
          ...props,
        }}
      >
        {children}
      </MuiTextField>

      <ValidationMessages fieldName={field.name} />
    </Stack>
  )
}

TextField.displayName = 'FormikMaterialUITextField'
